import { Grid, Stack, Typography } from "@mui/material";
import { HoverStyledCard } from "components/HoweCard";
import React from "react";
import { useSelector } from "react-redux";

const SalesPaper = ({ sales, header, refund }) => (
  <HoverStyledCard
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      py: 2,
      backgroundColor: "primary.darker",
      // backgroundColor: "warning.main",
    }}
    elevation={3}
  >
    <Typography
      color="white"
      sx={{ typography: { xl: "h4", lg: "h4", md: "h5", xs: "h6" } }}
    >
      {header}
    </Typography>
    <Typography
      color="white"
      marginTop={3}
      sx={{ typography: { xl: "h2", lg: "h2", md: "h3", xs: "h4" } }}
    >
      Rs {sales ?? "0"}/-
    </Typography>
    <Typography
      color="white"
      sx={{ typography: { xl: "h5", lg: "h5", md: "h6", xs: "h6" } }}
    >
      Refunds: Rs {refund ?? "0"}/-
    </Typography>
  </HoverStyledCard>
);

const SalesStatistics = () => {
  const statistics = useSelector((state) => state.statistics.item);

  return (
    <Stack direction="column">
      <Typography variant="h4" color="text.secondary">
        Sales
      </Typography>
      <Grid spacing={1} container>
        <Grid item xl={3} xs={6} md={6}>
          <SalesPaper
            header="Today"
            sales={statistics?.sales_today.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
            refund={statistics?.refunds_today.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
          />
        </Grid>
        <Grid item xl={3} xs={6} md={6}>
          <SalesPaper
            header="This month"
            sales={statistics?.sales_this_month.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
            refund={statistics?.refunds_this_month.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
          />
        </Grid>
        <Grid item xl={3} xs={6} md={6}>
          <SalesPaper
            header="This year"
            sales={statistics?.sales_this_year.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
            refund={statistics?.refunds_this_year.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
          />
        </Grid>
        <Grid item xl={3} xs={6} md={6}>
          <SalesPaper
            header="Total"
            sales={statistics?.total_sales.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
            refund={statistics?.total_refunds.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default SalesStatistics;
